import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'

import { RootState } from '@Root/slices'

export default function useUser() {
  const user = useSelector((state: RootState) => state.user)

  const { isLogin } = user
  const location = useLocation()

  const getCurrentUrl = (): string => {
    return `${process.env.REACT_APP_LAND_WEB_URL}${location?.pathname}`
  }

  const getNaverLoginUrl = (): string => {
    return `${process.env.REACT_APP_LOGIN_URL}&url=${getCurrentUrl()}`
  }

  const getNaverLogoutUrl = (): string => {
    return `${process.env.REACT_APP_LOGOUT_URL}&url=${getCurrentUrl()}`
  }
  const login = (): string | null => {
    if (isLogin) {
      return null
    }

    window.location.href = getNaverLoginUrl()
    return getNaverLoginUrl()
  }
  const logout = (): void => {
    if (!isLogin) {
      return
    }

    window.location.href = getNaverLogoutUrl()
  }
  return {
    user,
    login,
    logout,
  }
}
